import scroll from '~/app/Common/Scroll/index';
import initDetailsLightbox from '~/app/utils/initDetailsLightbox';

/**
 * Инициализация выбиратора.
 */
function main(): void
{
	scroll();
	
	const path = window.location.pathname;
	
	if ( /^\/choose\/apartment\/?$/.test( path ) )
	{
		import ( /* webpackChunkName: "choose-apartment" */ './Index/index' )
			.then( ( module ) => module.default() );
			
			const articleDetailsElements = document.querySelectorAll(
				'body>div.popup>details',
			) as NodeListOf<HTMLElement>;
			
			if ( articleDetailsElements.length !== 0 )
			{
				initDetailsLightbox( articleDetailsElements );
			}
	}
	else
	{
		import ( /* webpackChunkName: "choose-card" */ './Card/index' )
			.then( ( module ) => module.default() );
	}
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/index.ts